module.exports = __webpack_public_path__ + "img/logo-klm.210b8d7d.png";